var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadio = function SvgRadio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 58 46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 34c-.454 0-.903.09-1.322.263l2.029 2.03a1 1 0 1 1-1.414 1.414l-2.18-2.18A3.5 3.5 0 1 0 16.5 34"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 40,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 32.9a5 5 0 0 0 2 0v-3.4a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zM26 31.974V29.5a.5.5 0 0 0-.5-.5h-.734a.507.507 0 0 0-.473.681c.336.913.929 1.71 1.707 2.293M28 23.1v3.4a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3.4a5 5 0 0 0-2 0M24.766 27h.734a.5.5 0 0 0 .5-.5v-2.474a5.04 5.04 0 0 0-1.707 2.293.507.507 0 0 0 .473.681M37.82 12.655l.967-2.993a.5.5 0 0 0-.475-.654L34.663 9a.5.5 0 0 0-.476.657l.993 3.007a.5.5 0 0 0 .477.343l1.69-.007a.5.5 0 0 0 .473-.345"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 40,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.82 12.655.967-2.993a.5.5 0 0 0-.475-.654L19.663 9a.5.5 0 0 0-.476.657l.993 3.007a.5.5 0 0 0 .477.343l1.69-.007a.5.5 0 0 0 .473-.345"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 5,
    y: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17h26a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1m16.388-9.19c.365-.51.955-.812 1.582-.81h5.06c.627-.002 1.217.3 1.582.81a2.03 2.03 0 0 1 .289 1.814l-1.292 4A1.97 1.97 0 0 1 37.739 15h-2.478a1.97 1.97 0 0 1-1.87-1.376l-1.292-4a2.03 2.03 0 0 1 .289-1.814M29 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-11.612.81c.365-.51.955-.812 1.582-.81h5.06c.627-.002 1.217.3 1.582.81a2.03 2.03 0 0 1 .289 1.814l-1.292 4A1.97 1.97 0 0 1 22.739 15h-2.478a1.97 1.97 0 0 1-1.87-1.376l-1.292-4a2.03 2.03 0 0 1 .289-1.814M8 19.278V20a1 1 0 0 1-2 0v-.722a2 2 0 1 0 2 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 40,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 31.974a5.04 5.04 0 0 0 1.707-2.293.507.507 0 0 0-.473-.681H32.5a.5.5 0 0 0-.5.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 49,
    y: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 34c-.454 0-.903.09-1.322.263l2.029 2.03a1 1 0 1 1-1.414 1.414l-2.18-2.18A3.5 3.5 0 1 0 41.5 34M32 24.026V26.5a.5.5 0 0 0 .5.5h.734a.507.507 0 0 0 .473-.681A5.04 5.04 0 0 0 32 24.026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 0H2a2 2 0 0 0-2 2v42a2 2 0 0 0 2 2h54a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M13 6a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3zM3 9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm3 34a3 3 0 1 1 0-6 3 3 0 0 1 0 6m1-18a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.5 18a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11M29 43a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-8a7 7 0 1 1 7-7 7.01 7.01 0 0 1-7 7m12.5 8a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11M52 43a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-1-18a4 4 0 1 1 0-8 4 4 0 0 1 0 8m4-12a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 19a1.99 1.99 0 0 0-1.722 1H50a1 1 0 0 1 0 2h-.722A2 2 0 1 0 51 19"
  }))));
};
export default SvgRadio;